import { SwTrack } from "app/services/SwTrack";

// trackSideBar should be in separate file (not in utils.ts) to avoid dependency recursion
// (track.ts -> ... -> CustomUrlBuilderService.ts ... -> utils.ts -> SwTrack.ts -> track.ts)
export const trackSideBar = (isOpen: boolean): void => {
    SwTrack.all.dispatchTrackEvent("filter side bar", isOpen ? "expand" : "collapse", "menu");
};
